import { render, staticRenderFns } from "./ReferenceLibrary.vue?vue&type=template&id=a3167388&scoped=true"
import script from "./ReferenceLibrary.vue?vue&type=script&lang=js"
export * from "./ReferenceLibrary.vue?vue&type=script&lang=js"
import style0 from "./ReferenceLibrary.vue?vue&type=style&index=0&id=a3167388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3167388",
  null
  
)

export default component.exports